import { useModuleStyles } from '@/common/hooks';
import { BaseModuleProps } from '@/common/types';
import React from 'react';
import styles from './Brands.module.scss';

import {
  CONTAINER_OPTIONS,
  CONTENT_LAYOUT_OPTIONS,
  HEADING_ALIGNMENT_OPTIONS,
  MODULE_FILL_TYPE_OPTIONS,
  MODULE_FLOW_DIRECTION_OPTIONS,
  TITLE_SIZE_OPTIONS,
  TITLE_TYPE_OPTIONS,
} from '@/common/constants';
import { HeadingBlock, HeadingBlockProps } from '@/components/blocks/HeadingBlock/HeadingBlock';
import { CTAProps } from '@/components/CTA';
import { BrandLogoProps, BrandsContent } from './BrandsContent/BrandsContent';

export interface BrandsProps extends BaseModuleProps {
  brands: BrandLogoProps[];
  brandsCtas?: CTAProps[];
  brandsCtaCaption?: string;
}

export const Brands: React.FC<BrandsProps> = ({
  anchorTag = undefined,
  container = CONTAINER_OPTIONS.CONTAINED,
  fillType = MODULE_FILL_TYPE_OPTIONS.BASE,
  gradientFillToken,
  layout = CONTENT_LAYOUT_OPTIONS.CONTENT_LEADING,
  flowDirection = MODULE_FLOW_DIRECTION_OPTIONS.ROW,
  eyebrow,
  title,
  titleSize = TITLE_SIZE_OPTIONS.LARGE,
  titleType = TITLE_TYPE_OPTIONS.H2,
  bodyRichTextAsHTML,
  alignment = HEADING_ALIGNMENT_OPTIONS.CENTER,
  ctas,
  caption,
  brands,
  brandsCtaCaption,
  brandsCtas,
}) => {
  const headingConfig: HeadingBlockProps = {
    eyebrow,
    title,
    titleSize,
    titleType,
    bodyRichTextAsHTML,
    alignment,
    ctas,
    caption,
  };

  const { sectionStyles, moduleBaseStyles } = useModuleStyles({
    container,
    fillType,
    gradientFillToken,
    flowDirection,
    layout,
    moduleClassName: 'module-brands',
    styles,
  });

  return (
    <section className={sectionStyles} id={anchorTag}>
      <div className={moduleBaseStyles}>
        <HeadingBlock {...headingConfig} />
        <BrandsContent brands={brands} ctas={brandsCtas} caption={brandsCtaCaption} />
      </div>
    </section>
  );
};
